import { List, Typography } from 'antd'
import AffectedValue from './components/AffectedValue'
import { AffectedValueProps } from './components/AffectedValue/types'
import { AffectedValuesProps } from './types'

const AffectedValues: React.FC<AffectedValuesProps> = ({ items }) => {
  const toValues = (item: AffectedValueProps, index: number) => {
    const { label, value, deletable, hidden } = item
    if (hidden || !value) return null
    const key = `${label?.toString()}-${value?.toString()}-${index}`
    if (Array.isArray(value)) {
      if (value.length === 0) return null
      return (
        <List
          key={key}
          split={false}
          size="small"
          header={
            <>
              <Typography.Text
                type={deletable ? 'danger' : undefined}
                delete={deletable}
              >
                {label}
              </Typography.Text>
              :
            </>
          }
        >
          {value.reduce((children, child, index) => {
            if (!child.value || child.hidden) return children
            children.push(
              <List.Item key={`${key}-${index}`}>
                {toValues(child, index)}
              </List.Item>
            )
            return children
          }, Array<JSX.Element>())}
        </List>
      )
    }
    return <AffectedValue key={key} label={label} value={value} />
  }
  if (!items) return null
  return <>{items.map((item, index) => toValues(item, index))}</>
}

export default AffectedValues
